const ajax = require('sma.common/ajax');

class EmailVerification extends Backbone.View {
	constructor(config) {
		super();
		this.setElement($('.sma-js-unverified-email-notification'));
	}

	get events() {
		return {
			'click .sma-js-send-verification': 'resendEmailVerification',
		}
	}

	resendEmailVerification(e) {
		e.preventDefault();

		ajax.post({
			url: reverse('resend-email-verification'),
			callback: (response) => {
				$('.sma-js-unverified-email-notification').remove();
			}
		});
	}
}

module.exports = EmailVerification;
